module.exports = __webpack_public_path__ + "src/assets/_textures/popups/header.png";